import * as React from 'react';
import { Dialog, DialogContent, DialogActions, Button, DialogTitle, IconButton, Grid, Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Guid } from 'guid-typescript';
import { getModuleQuestionsCall } from 'src/effects/api/api.module';
import PullFromRepositoryPreviewComponent from './PullFromRepositoryPreviewComponent';
import { toast } from 'react-toastify';
import { TOSTAR_POSITION } from 'src/constants/NotificationMessageConstant';

export default class PullFromRepositoryComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: false,
            fullWidth: true,
            maxWidth: 'sm',
            modules: [],
            moduleValue: '',
            moduleQuestions: [],
            question: undefined,
            moduleId: 0,
            isModuleChanged: false,
            allData: {}
        }

        this.handleClose = this.handleClose.bind(this);
        this.handleModuleChange = this.handleModuleChange.bind(this);
        this.handleQuestionChange = this.handleQuestionChange.bind(this);
        this.handleApply = this.handleApply.bind(this);
    }

    componentDidMount() {
        const url = window.location.href.split('/');
        const paramId = url[url.lastIndexOf('questions') + 1];

        if (this.props.modules && this.props.modules.length > 0) {
            this.setState({ modules: this.props.modules });
        }
        else {
            const modules = this.props.getModuleList();
            this.setState({ modules });
        }

        this.setState({ moduleId: paramId, allData: this.props.allData });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.modules && nextProps.modules.length > 0) {
            this.setState({ modules: nextProps.modules });
        }
        else {
            const modules = nextProps.getModuleList();
            this.setState({ modules });
        }

        this.setState({ allData: this.props.allData });
    }

    handleClose() {
        this.props.onDialogClose();
    }

    handleModuleChange = (e: any) => {
        this.setState({ moduleValue: e.target.value, isModuleChanged: true, question: undefined, error: undefined, success: undefined },
            () => this.getModuleQuestions(e.target.value));
    }

    handleQuestionChange = (e: any) => {
        if (e.target.value) {
            const pulledQuestionJson = this.state.moduleQuestions.find((q: any) => q.id === e.target.value);
            const questionJson = pulledQuestionJson.question_json;
            const question = JSON.parse(questionJson);
            question.isdirty = true;
            if ((this.props.allData.module.id === this.state.moduleValue && !pulledQuestionJson.isExcluded) || (this.props.allData.module.id !== this.state.moduleValue)) {
                question.question_id = Guid.create().toString();
            }
            
            this.setState({ question, questionValue: e.target.value, error: undefined, success: undefined });
        }
    }

    getModuleQuestions = (moduleId: any) => {
        getModuleQuestionsCall(moduleId).then((res: any) => {
            this.setState({ moduleQuestions: res.data.payload });
        })
    }

    handleApply = () => {
        if (this.state.question) {
            this.props.updateModule({
                data: {
                    clusterIndex: this.props.clusterIndex,
                    pageNumber: this.props.pageNumber,
                    value: this.state.question
                },
                field: 'pullQuestionFromRepo'
            });
            toast.success('Question pulled successfully.', { position: TOSTAR_POSITION })
        }
    }

    render() {
        return (
            <>
                <Dialog
                    id="pullFromRepoDialog"
                    fullWidth={this.state.fullWidth}
                    hideBackdrop={true}
                    maxWidth={this.state.maxWidth}
                    open={this.props.showDialog}
                    aria-labelledby="max-width-dialog-title"
                    className="applicationDialog"
                >
                    <div className="dialogWrapper">
                        <div className="dialogHead">
                            <DialogTitle id="max-width-dialog-title" className="dialogTitle">Pull Question
                        <IconButton aria-label="Close" className="closeButton" onClick={this.handleClose}>
                                    <CloseIcon />
                                </IconButton>
                                <hr className="HZDivider" />
                            </DialogTitle>

                        </div>
                        <div className="dialogContent">
                            <DialogContent>
                                <div id="pullFromRepoDialogBody" className="dialogBox">
                                    <Grid container={true} spacing={24}>
                                        <Grid item={true} xs={12}>

                                            <div>
                                                <FormControl margin="normal" required={false} fullWidth={true}>
                                                    <InputLabel htmlFor="classType">Modules</InputLabel>
                                                    <Select
                                                        fullWidth={true}
                                                        value={this.state.moduleValue ? this.state.moduleValue : ''}
                                                        onChange={this.handleModuleChange}
                                                    >
                                                        {
                                                            this.state.modules && this.state.modules.length > 0 && (this.state.modules.map((module: any) => {
                                                                return (
                                                                    <MenuItem key={Guid.create().toString()} value={module.id}>
                                                                        {module.name}
                                                                    </MenuItem>
                                                                )
                                                            }))
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            {
                                                <div>
                                                    <FormControl margin="normal" required={false} fullWidth={true}>
                                                        <InputLabel htmlFor="classType">Questions</InputLabel>
                                                        <Select
                                                            fullWidth={true}
                                                            value={this.state.questionValue ? this.state.questionValue : ''}
                                                            onChange={this.handleQuestionChange}
                                                        >
                                                            {
                                                                this.state.moduleQuestions.map((q: any) => {
                                                                    return (
                                                                        <MenuItem key={Guid.create().toString()} value={q.id}>
                                                                            {q.question && q.question.question_number && 'Q. ' + q.question.question_number + '-'} {' version '}{q.version}{' - '}{q.title}
                                                                        </MenuItem>
                                                                    )
                                                                })
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            }
                                        </Grid>
                                        <Grid item={true} xs={12}>
                                            {
                                                this.state.question && (
                                                    <PullFromRepositoryPreviewComponent
                                                        question={this.state.question}
                                                    />
                                                )
                                            }
                                        </Grid>
                                    </Grid>
                                </div>
                            </DialogContent>
                        </div>
                        <DialogActions>
                            <Button color="primary" className="btn-blue-primary" onClick={this.handleApply}>
                                Apply Changes &nbsp; >
                                </Button>
                        </DialogActions>
                    </div>
                </Dialog>
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/questions/PullFromRepositoryComponent.tsx